import { render, staticRenderFns } from "./HtmlElement.vue?vue&type=template&id=1b013ddf&scoped=true&"
import script from "./HtmlElement.vue?vue&type=script&lang=js&"
export * from "./HtmlElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b013ddf",
  null
  
)

export default component.exports